import { buildApiUrl } from "./apiConfig";
import { apiClient } from "./apiClient";

export function resolveBadgeDownloadUrl(
    downloadUrl?: string | null,
    badgeUrl?: string | null
): string | null {
    if (downloadUrl?.includes("/thumb-") && badgeUrl) {
        return badgeUrl;
    }
    return downloadUrl ?? badgeUrl ?? null;
}

function filenameFromUrl(url: string): string | null {
    try {
        const pathname = new URL(url).pathname;
        const basename = pathname.split("/").pop();
        return basename && basename.length > 0 ? basename : null;
    } catch {
        return null;
    }
}

export async function downloadCmsAsset(
    sourceUrl: string,
    filename?: string
): Promise<void> {
    const fetchUrl = `${buildApiUrl("api/courses/completion-badge/download")}?url=${encodeURIComponent(sourceUrl)}`;
    const res = await apiClient(fetchUrl, {
        credentials: "include",
    });

    if (res.status === 401) {
        window.location.href = "/login";
        return;
    }

    if (!res.ok) {
        throw new Error(`Failed to download badge (HTTP ${res.status})`);
    }

    const blob = await res.blob();
    const blobUrl = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = blobUrl;
    anchor.download = filename ?? filenameFromUrl(sourceUrl) ?? "polaris-course-badge.png";
    anchor.click();
    URL.revokeObjectURL(blobUrl);
}

export async function downloadCompletionBadge(
    downloadUrl?: string | null,
    badgeUrl?: string | null,
    filename?: string
): Promise<void> {
    const url = resolveBadgeDownloadUrl(downloadUrl, badgeUrl);
    if (!url) {
        throw new Error("No badge download URL available");
    }
    await downloadCmsAsset(url, filename);
}
